export const app = {
  name: '%{companyName} Admin',
  subtitle: 'Admin',
};